export default __webpack_public_path__ + "static/media/token_bottom.dc46c14d.png";